import axios from "axios";
import { conn } from "../../Utilt/conn";
import { updateTransactionCount, updateTransactionValue, updateTotalAccounts, updateMaleUsers, updateFemaleUsers } from "../../ReduxStore/Metric";
//import { config } from "../../Utilt/Config";
const { FormatMoney } = require('format-money-js');


const fm = new FormatMoney({
    decimals: 2
});




export const getTransactionCount = async (id, dispatch) => {

    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")

    const config = {
        headers: {
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': '*',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    try {
        const response = await axios.post(conn + "/admin/metrics/transactions/count", {
            "fromDate": "2022-08-15T23:59:59.000Z",
            "toDate": "2022-10-24T23:59:59.000Z"
        }, config);
        dispatch(updateTransactionCount(response.data.count))
    } catch (err) {
        console.log(err);
    }
}

export const getTransactionValue = async (id, dispatch) => {

    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")

    const config = {
        headers: {
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': '*',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    try {
        const response = await axios.post(conn + "/admin/metrics/transactions/total", {
            "fromDate": "2022-08-15T23:59:59.000Z",
            "toDate": "2022-10-24T23:59:59.000Z"
        }, config);
        //console.log("Transacted" + response.data.count)
        dispatch(updateTransactionValue(response.data.data.total_within))
    } catch (err) {
        console.log(err);
    }
}

export const getTotalAccounts = async (id, dispatch) => {

    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")

    const config = {
        headers: {
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': '*',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    try {
        const response = await axios.post(conn + "/admin/metrics/accounts/count", {
            "fromDate": "2022-08-15T23:59:59.000Z",
            "toDate": "2022-10-24T23:59:59.000Z"
        }, config);
        dispatch(updateTotalAccounts(response.data.count))
    } catch (err) {
        console.log(err);
    }
}


export const getUserCount = async (id, dispatch) => {

    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")

    const config = {
        headers: {
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': '*',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    try {
        const response = await axios.post(conn + "/admin/metrics/users/count", {
            "fromDate": "2022-08-15T23:59:59.000Z",
            "toDate": "2022-10-24T23:59:59.000Z"
        }, config);
        dispatch(updateMaleUsers(response.data.data.male))
        dispatch(updateFemaleUsers(response.data.data.female))
    } catch (err) {
        console.log(err);
    }
}

export const nFormatter = (num, digits) => {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "B" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }


export const amountprefix = (value) => {

    if (parseFloat(value) > 0 && parseFloat(value) < 999) {
        return value;
    }

    if (parseFloat(value) > 999 && parseFloat(value) < 999999) {
        return fm.from((parseFloat(value) / 1000), { symbol: '' }).toString() + "K";
    }

    if (parseFloat(value) > 999999 && parseFloat(value) < 999999999) {
        return fm.from((parseFloat(value) / 1000000), { symbol: '' }).toString() + "M";
    }

    if (parseFloat(value) > 999999999 && parseFloat(value) < 999999999999) {
        return fm.from((parseFloat(value)/ 1000000000), { symbol: '' }).toString() + "B";
    }

}


